import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GraduationCap } from "@phosphor-icons/react";

const CURRENCIES = ["TRY", "USD", "EUR", "GBP", "AED", "CHF"];

export default function RegisterPage() {
  const { register, error } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", currency: "TRY" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  function onChange(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const ok = await register(form);
    setLoading(false);
    if (ok) nav("/");
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAF9F6]">
      <form onSubmit={onSubmit} className="w-full max-w-md space-y-6 bg-white border border-border rounded-lg p-8" data-testid="register-form">
        <div className="flex items-center gap-2 text-[#3A5A40]">
          <GraduationCap size={28} weight="duotone" />
          <span className="font-display font-bold text-xl">EduFin</span>
        </div>
        <div>
          <h2 className="font-display text-3xl font-bold">Yeni hesap oluştur</h2>
          <p className="text-muted-foreground mt-1">Birkaç saniyede öğretmen panelinize erişin.</p>
        </div>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Ad Soyad</Label>
            <Input id="name" required value={form.name} onChange={(e) => onChange("name", e.target.value)} data-testid="register-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" type="email" required value={form.email} onChange={(e) => onChange("email", e.target.value)} data-testid="register-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Şifre (en az 6 karakter)</Label>
            <Input id="password" type="password" required minLength={6} value={form.password} onChange={(e) => onChange("password", e.target.value)} data-testid="register-password-input" />
          </div>
          <div className="space-y-2">
            <Label>Para birimi</Label>
            <Select value={form.currency} onValueChange={(v) => onChange("currency", v)}>
              <SelectTrigger data-testid="register-currency-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {CURRENCIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        {error && <div className="text-sm text-[#D97757] bg-[#FFF3E0] border border-[#FFE0B2] rounded-md px-3 py-2" data-testid="register-error">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full bg-[#3A5A40] hover:bg-[#2E4833] text-white h-11" data-testid="register-submit-button">
          {loading ? "Oluşturuluyor…" : "Hesap Oluştur"}
        </Button>
        <div className="text-sm text-muted-foreground">
          Zaten hesabınız var mı?{" "}
          <Link to="/giris" className="text-[#3A5A40] font-medium hover:underline" data-testid="goto-login-link">Giriş yapın</Link>
        </div>
      </form>
    </div>
  );
}
